const DefaultData = {
    APISERVERURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    APILOCALURL: 'http://localhost:5126/api/',
    APIACTIVEURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    TENANTID:'landair',
    DEFAULTCOMPANYID: '8963a534-24a3-45a8-94f1-6c0573b8a9cf',
    DEFAULTBRANCHID: '6fc3b732-d2eb-4ab1-a516-d332e60bec5b',
    DEFAULTCURRENCY: 'INR',
    WEBSITE:'https://landairtravels.com',
    DEFAULTCOMPANYEMAIL: 'support@landairtravels.com',
    DEFAULTCOMPANYPHONENUMBER: '7995331116',
    DEFAULTCOMPANYWHATSAPPNUMBER:'7995331116',
    DEFAULTCOMPANYGST: '36AAACL6045R1Z0',
    DEFAULTCOMPANYNAME: 'LAND AIR TRAVELS PVT LTD',
    DEFAULTBRANDNAME: 'LAND AIR',
    DEFAULTCOMPANYADDRESS:'GF-3, Tourism Plaza, 6-3-869/A,Greenlands, Begumpet,Hyderabad, Telangana 500016',
    FACEBOOKURL:'https://www.facebook.com/landair',
    TWITTERURL:'https://x.com/landair',
    INSTGRAMURL:'https://www.instagram.com/landair',
    THEMECOLOR1:"#031B34",
    THEMECOLOR2:"#BB2D3B",
    THEMECOLOR3:"#ffffff",
    THEMECOLOR4:"#000000",
    LANDINGPAGETITLE:"Empowering the Future of Travel Booking",
    LANDINGPAGESUBTITLE:"One stop solution for your travel business",
    B2BWEBSITE:"https://b2b.landair.in/",
    FOOTERCOPYRIGHTS:"1974 - 2025 LAND AIR TRAVELS",
    FOOTERSUBTITLE:"Transforming your dream into a beautiful journey full of happiness.",
};

export default DefaultData;